import { clsx } from "clsx";

import type { ReactNode } from "react";

type FlickerDirection = "tl-br" | "tr-bl";

const DIRECTION_CLASSES: Record<FlickerDirection, readonly [string, string]> = {
  "tl-br": ["btn-flicker--top-left", "btn-flicker--bottom-right"],
  "tr-bl": ["btn-flicker--top-right", "btn-flicker--bottom-left"],
};

interface IButtonFlickerProps {
  direction?: FlickerDirection;
  className?: string;
  children: ReactNode;
}

export function ButtonFlicker({ direction = "tl-br", className, children }: IButtonFlickerProps) {
  const [firstClass, secondClass] = DIRECTION_CLASSES[direction];

  return (
    <div className={clsx("flex-center", className)}>
      <div className={clsx("btn-flicker-wrapper")}>
        <span className={clsx("btn-flicker", firstClass)} aria-hidden />
        {children}
        <span className={clsx("btn-flicker", secondClass)} aria-hidden />
      </div>
    </div>
  );
}
